
import Swiper, {EffectFade, Autoplay, Pagination, Navigation} from 'swiper';

export default {
    init() {
        Swiper.use(EffectFade);

        let image_sliders = document.getElementsByClassName('image_slider');
        if(image_sliders) {
            // mySwiper = new Swiper('')
            for(let i = 0; i < image_sliders.length; i++) {
                this.initialize_swipers(image_sliders[i]);
            }
        } 

        document.querySelectorAll('.swiper-container.modal-swiper').forEach(swiper => {
            Swiper.use(Pagination)
            // let desktop = 1200;
            // let mobile = 690;
            let modal_swiper = new Swiper(swiper, {
                allowTouchMove: true,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                loop: true,
                pagination: {
                    el: '.image-pagination',
                    clickable: true
                }
            });
        })

        /** Home page slider. */
        let home_slider = document.querySelector('.home-slider');
        if(home_slider) {
            Swiper.use(Autoplay);
            Swiper.use(Pagination)
            let swiper = new Swiper(home_slider, {
                direction: 'horizontal',
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 3000
                },
                fadeEffect: { crossFade: true },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    // init: this.move_pagination,
                    // slideChangeTransitionStart: this.move_pagination
                }
            })

            // swiper.autoplay.start();
        }

        //sliders that appear under the header.
        let header_sliders = document.querySelectorAll('.header-slider').forEach((slider) => {
            Swiper.use(Autoplay);
            Swiper.use(Pagination)
            let swiper = new Swiper(slider, {
                direction: 'horizontal',
                loop: true,
                allowTouchMove: true,
                autoplay: {
                    delay: 3000
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
            })
        });

        let timelines = document.querySelectorAll('.timeline').forEach(timeline => {
            let desktop = 1200;
            let mobile = 690;
            Swiper.use(Navigation);
            // let width;
            if(window.innerWidth >= desktop) {
                let swiper = new Swiper(timeline, {
                    allowTouchMove: true,
                    // width: 400,
                    spaceBetween: 20,
                    // loop: true,
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    pagination: {
                        el: '.timeline-pagination',
                        clickable: true
                    },
                    navigation: {
                      nextEl: ".timeline-next",
                      prevEl: ".timeline-prev",
                    },
                    breakpoints: {
                        991: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            spaceBetween: 20,
                        },
                        1085: {
                            slidesPerGroup: 2,
                            spaceBetween: 20,
                        },
                        1280: {
                            slidesPerView: 'auto',
                            spaceBetween: 20,
                        }
                    },
                });
                timeline.addEventListener('keydown', e => {
                    if(e.keyCode === 37) {
                        swiper.slidePrev();
                    }
                    if(e.keyCode === 39) {
                        swiper.slideNext();
                    }
                })
            } else if(window.innerWidth < desktop && window.innerWidth > mobile) {
                let swiper = new Swiper(timeline, {
                    allowTouchMove: true,
                    width: 500,
                    spaceBetween: 20,
                    // loop: true,
                    slidesPerView: 'auto',
                    pagination: {
                        el: '.timeline-pagination',
                        clickable: true
                    },
                });
            } else {
                let swiper = new Swiper(timeline, {
                    allowTouchMove: true,
                    spaceBetween: 20,
                    // loop: true,
                    slidesPerView: 'auto',
                    pagination: {
                        el: '.timeline-pagination',
                        clickable: true
                    },
                });
            }

            // Swiper.use(Pagination)
            // let swiper = new Swiper(timeline, {
            //     allowTouchMove: true,
            //     width: 600,
            //     spaceBetween: 20,
            //     pagination: {
            //         el: '.timeline-pagination',
            //         // clickable: true
            //     },
            // });
        })

        // init copy image slider swipers
        document.querySelectorAll('.section.copy-image-section').forEach( section => {
            if (!section.querySelector('.swiper-container.slider-swiper')) {
                return false;
            }

            function change_accordion(swiper) {
                let curr_slide = swiper.activeIndex
                let accordions = section.querySelector('.slider-accordion').querySelectorAll('.slider-accordion__content');
                let curr_accordion = accordions[curr_slide];
                accordions.forEach(accordion => {
                    if(accordion !== curr_accordion) {
                        accordion.classList.remove('visible')
                        accordion.previousElementSibling.classList.remove('active');
                    } else {
                        accordion.classList.add('visible')
                        accordion.previousElementSibling.classList.add('active');
                    }
                })
            }

            let swiperContainer = section.querySelector('.swiper-container.slider-swiper');
            Swiper.use(Pagination)
            let swiper = new Swiper(swiperContainer, {
                allowTouchMove: true,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                pagination: {
                    el: '.image-pagination',
                    clickable: true
                },
                on: {
                    slideChangeTransitionStart: change_accordion
                }
            });


            section.querySelector('.slider-accordion')
            .querySelectorAll('.slider-accordion__heading')
            .forEach( (item, index) => {
                let slide_changed = () => {
                    var top  = window.pageYOffset || document.documentElement.scrollTop;
                    swiper.slideTo(index, 700);
                    // item.previousElementSibling.classList.add('visible')
                    section.querySelector('.slider-accordion').querySelectorAll('.slider-accordion__content').forEach( (content, index) => {
                        if(item.nextElementSibling !== content) {
                            content.classList.remove('visible');
                            content.previousElementSibling.classList.remove('active');
                        } else {
                            content.classList.add('visible');
                            content.previousElementSibling.classList.add('active');
                        }
                    } );
                    window.scrollTo(0, top)
                }
                item.addEventListener('click', () => {
                    slide_changed();
                });
                item.addEventListener('focusin', () => {
                    slide_changed();
                })
                item.addEventListener('mouseover', () => { 
                    // swiper.slideTo(index, 700) 
                    // // item.previousElementSibling.classList.add('visible')
                    // section.querySelector('.slider-accordion').querySelectorAll('.slider-accordion__content').forEach( (content, index) => {
                    //     if(item.nextElementSibling !== content) {
                    //         content.classList.remove('visible');
                    //         content.previousElementSibling.classList.remove('active');
                    //     } else {
                    //         content.classList.add('visible');
                    //         content.previousElementSibling.classList.add('active');
                    //     }
                    // } );
                    slide_changed();
                });
            });

        });
    },
    /**
     * 
     * @param {HTMLElement} image_slider the element to initialize swiper for.
     */
    initialize_swipers(image_slider) {
        let swiper_container = image_slider.querySelector('.swiper-container');
        Swiper.use(Pagination)
        let swiper = new Swiper(swiper_container, {
            direction: 'horizontal',
            loop: true,
            fadeEffect: { crossFade: true },
            pagination: {
                el: '.swiper-pagination',
                // clickable: true
            },
        })
    },

    move_pagination(swiper) {
        // let swiper_el = swiper.$el;
        let pagination = swiper.el.querySelector('#header-controls');
        // console.log(window.innerWidth);
        let that = this;

		if(pagination !== null){
			let title = swiper.slides[swiper.activeIndex].querySelector('.container.section .content p');

			if(title !== null){

                function getPosition(element) {
                    var xPosition = 0;
                    var yPosition = 0;
                
                    while(element) {
                        xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
                        yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
                        element = element.offsetParent;
                    }
                
                    return { x: xPosition, y: yPosition };
                }
                
                var isAndroid = /(android)/i.test(navigator.userAgent);
                let extra;

                if(window.innerWidth < 1200) {
                    if(isAndroid) {
                        extra = -170;
                    } else {
                        extra = -50;
                    }
                } else {
                    extra = 50;
                }

                // let extra = (window.innerWidth < 1200) ? -170 : 50
                
                // let offset_top = title.scrollTop;
                // var offset_top = window.pageYOffset + title.getBoundingClientRect().top
                var offset_top = getPosition(title).y - 100;
                let height = $(title).height();
				var actualBottom = offset_top + height + extra;

				pagination.style.top = actualBottom + 'px';
			}
		}
    }
}